// extracted by mini-css-extract-plugin
module.exports = {"claimModal":"styles_claimModal__FzzOa","pointsBox":"styles_pointsBox__aMoFa","outsideButton":"styles_outsideButton__zfrbg","perk":"styles_perk__BE89N"};